<template>
  <v-container fill-height fluid grid-list-xl>
    <v-row justify="center">
      <v-col cols="12">
        <material-card
          color="green"
          flat
          full-width
          title="Роли пользователей"
        >
          <v-data-table
            :headers="headers"
            :items="data"
            :options.sync="options"
            :server-items-length="totalDesserts"
            :loading="loading"
            hide-default-footer
            class="elevation-1"
          >
            <template v-slot:top>
              <v-toolbar
                flat
              >
                <v-spacer />
                <v-dialog
                  v-model="dialog"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="red"
                      dark
                      class="mb-2"
                      v-bind="attrs"
                      v-on="on"
                    >
                      Новая роль
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span v-if="!disableName" class="headline">Добавление Роли</span>
                      <span v-if="disableName" class="headline">Редактирование Роли</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-text-field
                          v-model="editedItem.id"
                          label="Название роли"
                          :disabled="disableName"
                        />
                        <select-user :open-dialog="dialog" :users_default="editedItem.members" @update-users="UpdateSelected" />
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="close"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="save"
                      >
                        Save
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:item.members="{ item }">
              <v-chip
                v-for="m in item.members"
                :key="m.id"
                outlined
                color="blue"
              >
                {{ m.email || 'DELETED' }}
              </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon
                small
                class="mr-2"
                @click="editItem(item)"
              >
                mdi-pencil
              </v-icon>
              <v-icon
                small
                @click="deleteItem(item)"
              >
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Roles, setRole, deleteRole } from '@/graphql/users'
import { TransformFields } from '@/mixins/fields'
import SelectUser from '@/components/users/select'
export default {
  layout: 'dashboard',
  name: 'Roles',
  components: {
    SelectUser
  },
  apollo: {
    Roles: {
      query: Roles,
      result ({ data, loading, networkStatus }) {
        this.data = []
        for (const key in data.Roles) {
          const item = data.Roles[key]
          const members = []
          for (const ikey in item.members) {
            members.push(Object.assign({ id: item.members[ikey].Id }, TransformFields(item.members[ikey].Fields)))
          }
            this.data.push({
              id: item.id,
              members
            })
        }
        this.totalDesserts = this.data.length
        this.loading = false
      },
      update: data => data.Roles,
      deep: false
    }
    },
    data () {
      return {
        disableName: false,
         dialog: false,
        data: [],
        options: {},
        totalDesserts: 0,
        loading: false,
        editedItem: {},
        headers: [
          {
            sortable: false,
            text: 'Название роли (ID)',
            value: 'id'
          },
          {
            sortable: false,
            text: 'Члены',
            value: 'members'
          },
          { text: 'Actions', value: 'actions', sortable: false }
          ]
        }
    },
    watch: {
      dialog (val) {
        if (!val) {
          this.disableName = false
          this.editedItem = Object.assign({})
        }
      }
    },
    mounted () {
      this.$apollo.queries.Roles.refetch()
    },
      methods: {
        UpdateSelected (users) {
          this.editedItem.members = users
        },
        editItem (item) {
          this.disableName = true
          this.editedItem = Object.assign({}, item)
           this.dialog = true
        },
        deleteItem (item) {
             this.$apollo.mutate({
                mutation: deleteRole,
                variables: {
                  id: item.id
                }
             }).then((data) => {
                  this.$apollo.queries.Roles.refetch()
              }).catch((error) => {
                console.error(error)
              })
        },
        close () {
          this.dialog = false
        },
        save () {
           const members = []
           console.log(this.editedItem)
          for (const key in this.editedItem.members) {
            members.push(this.editedItem.members[key].id)
          }
           this.$apollo.mutate({
                mutation: setRole,
                variables: {
                  id: this.editedItem.id,
                  members
                }
             }).then((data) => {
                  this.$apollo.queries.Roles.refetch()
              }).catch((error) => {
                console.error(error)
              })

          this.close()
        }
      }
  }
</script>

<style>

</style>
